// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconBank.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconBank = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M15.3867 4.69336L8.00002 0L0.613281 4.69336V5.38673H15.3867V4.69336Z" />
    <path d="M16 14.1875H0V16H16V14.1875Z" />
    <path d="M14.8262 11.6807H1.17334V13.4932H14.8262V11.6807Z" />
    <path d="M4.85302 6.08021H2.3999V10.9874H4.85302V6.08021Z" />
    <path d="M13.6008 6.08021H11.1467V10.9874H13.6008V6.08021Z" />
    <path d="M9.22603 6.08021H6.77344V10.9874H9.22603V6.08021Z" />
  </BaseIcon>
);

export default IconBank;
